import { motion } from "motion/react";

const sizeVariants = {
  sm: { container: "gap-0.5", dot: "w-1 h-1" },
  md: { container: "gap-1", dot: "w-1.5 h-1.5" },
};

interface DotsLoaderProps {
  color?: string;
  size?: keyof typeof sizeVariants;
}

const DotsLoader = ({ color, size = "md" }: DotsLoaderProps = {}) => {
  const dots = [0, 1, 2];
  const { container, dot } = sizeVariants[size];
  return (
    <div className={`flex ${container} items-center justify-center`}>
      {dots.map((i) => (
        <motion.div
          key={i}
          className={`${dot} rounded-full`}
          style={{ backgroundColor: color ?? "#ffffff" }}
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            delay: i * 0.2,
            ease: "easeOut",
          }}
        />
      ))}
    </div>
  );
};

export default DotsLoader;
